"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = TabLayout;

var _react = _interopRequireWildcard(require("react"));

var _string = require("../../utils/string");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function TabLayout(props) {
  var className = props.className,
      onTabSelect = props.onTabSelect,
      onTabDeselect = props.onTabDeselect,
      _props$namespace = props.namespace,
      namespace = _props$namespace === void 0 ? '' : _props$namespace,
      _props$tabs = props.tabs,
      tabs = _props$tabs === void 0 ? [] : _props$tabs,
      render = props.render,
      onChange = props.onChange;

  var _useState = (0, _react.useState)(tabs.find(function (t) {
    return t.active;
  }) || tabs.filter(function (t) {
    return !t.disabled;
  })[0] || tabs[0]),
      _useState2 = _slicedToArray(_useState, 2),
      activeTab = _useState2[0],
      setActiveTab = _useState2[1];

  if (typeof render !== 'function') {
    return null;
  }

  tabs = tabs.map(function (tab, i) {
    return _objectSpread({
      id: tab.label ? (0, _string.slugify)(tab.label) : "tab-".concat(i)
    }, tab);
  });
  var containerClasses = ['tab-layout'];

  if (className) {
    containerClasses.push(className);
  }

  (0, _react.useEffect)(function () {
    if (typeof onTabSelect === 'function') {
      onTabSelect(activeTab);
    }

    return function () {
      if (typeof onTabDeselect === 'function') {
        onTabDeselect(activeTab);
      }
    };
  }, [activeTab]);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: containerClasses.join(' ')
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "tabs-menu"
  }, tabs.map(function (tab, i) {
    var content = typeof tab.render === 'function' ? tab.render(tab) : tab.label;
    var classes = ['tab', "".concat(tab.id)];

    if (tab.id === activeTab.id) {
      classes.push('tab-active');
    }

    return /*#__PURE__*/_react.default.createElement("div", {
      key: i,
      disabled: tab.disabled,
      onClick: function onClick() {
        if (activeTab.id !== tab.id && !tab.disabled) {
          setActiveTab(tab);

          if (typeof onChange === 'function') {
            onChange(tab, activeTab);
          }
        }
      },
      className: classes.join(' ')
    }, content);
  })), /*#__PURE__*/_react.default.createElement("section", {
    className: "tabs-content"
  }, render({
    activeTab: activeTab,
    tabs: tabs,
    setActiveTab: setActiveTab
  })));
}